export default __webpack_public_path__ + "static/Immunity_Bar-c4cf7c5d48192970bcecbb358b40fe2f.jpg";